import ConfirmationHost from './components/ConfirmationHost';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';
import * as React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Pages/Login';
import CompanyProfile from './Pages/CompanyProfile';
import './index.css';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { googleApiKey } from "./constants";
import { LoadScript } from "@react-google-maps/api";
import ClientProfile from "./Pages/ClientProfile";
import ClientHub from "./Pages/ClientHub";
import SiteManagement from "./Pages/SiteManagement";
import WorkerProfile from "./Pages/WorkerProfile";
import Assets from "./Pages/Assets";
import Allocations from "./Pages/Allocations";
import Timesheet from "./Pages/Timesheet";
import Invoices from "./Pages/Invoices";
import Tasks from "./Pages/Tasks";
import Dashboard from "./Pages/Dashboard";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Support from "./Pages/Support";
import Documentation from "./Pages/Documentation";
import WorkerFuturePage from "./Pages/WorkerFuturePage";
import WorkerCompany from "./Pages/WorkerCompany";
import WorkerTimesheets from "./Pages/WorkerTimesheets";
import WorkerOverview from "./Pages/WorkerOverview";
import StatsReports from "./Pages/StatsReports";
import JobMarket from "./Pages/JobMarket";
import PageLoader from './components/PageLoader';
import { installChunkLoadRecovery } from './utils/chunkLoadRecovery';

installChunkLoadRecovery();
onAuthStateChanged(auth, () => queryClient.clear())

const router = createBrowserRouter([
  { path: "/site-management", element: <SiteManagement /> },
  { path: "/client-hub", element: <ClientHub /> },
  {
    path: "/worker/overview",
    element: <WorkerOverview />,
  },
  {
    path: "/worker/timesheets",
    element: <WorkerTimesheets />,
  },
  {
    path: "/worker/invoices",
    element: <WorkerFuturePage />,
  },
  {
    path: "/worker/forms",
    element: <WorkerFuturePage />,
  },
  {
    path: "/worker/company",
    element: <WorkerCompany />,
  },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/stats-reports",
    element: <StatsReports />,
  },
  {
    path: "/job-market",
    element: <JobMarket />,
  },
  {
    path: "/companyProfile",
    element: <CompanyProfile />,
  },
  {
    path: "/tasks",
    element: <Tasks />,
  },
  {
    path: "/clients",
    element: <ClientProfile />,
  },
  {
    path: "/workers",
    element: <WorkerProfile />,
  },
  {
    path: "/assets",
    element: <Assets />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/allocations",
    element: <Allocations />,
  },
  {
    path: "/timesheet",
    element: <Timesheet />,
  },
  {
    path: "/invoices",
    element: <Invoices />,
  },
  {
    path: "/quotes",
    element: <Navigate to="/invoices?tab=quotes" replace />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/forms",
    element: <Documentation />,
  },
])

createRoot(document.getElementById("root")).render(
  <>
    <QueryClientProvider client={queryClient}>
      <ConfirmationHost />
    <Provider store={store()}>
      <LoadScript googleMapsApiKey={googleApiKey} libraries={["places"]}  >
        <RouterProvider router={router} />
        <PageLoader />
        <ToastContainer />
      </LoadScript>
    </Provider>
    </QueryClientProvider>
  </>
);
